import { Component, Host, h, State, Prop, Fragment, Event, EventEmitter, Listen, Element } from '@stencil/core';
import { $$$ } from '../../../utils/utils';
import { ImageProductLinkEvent } from './ImageProductLinkEvent';

@Component({
  tag: 'lilu-image-product-link',
  styleUrl: 'lilu-image-product-link.scss',
  shadow: true,
})
export class LiluImageProductLink {
  @Prop() productId: string;
  @Prop() titletext: string;
  @Prop() producturl: string;
  @Prop() priceType: string = 'normal';
  @Prop() price: string;
  @Prop() oldprice?: string;
  @Prop() addtocarttext: string;
  @Prop() top?: string;
  @Prop() left?: string;

  @State() open = false;

  private clickPrevent = false;
  private opening = false;
  private origLeft: string;
  private origTop: string;
  private debounce: any = null;

  @Element() el: HTMLElement;

  @Event()
  linkIsOpen: EventEmitter<ImageProductLinkEvent>;

  @Listen('linkIsOpen', { target: 'window' })
  closeAllInstances() {
    this.hide();
  }

  @Listen('keydown', { target: 'window' })
  handleKeyDown(ev: KeyboardEvent) {
    if (ev.key === 'Escape') {
      this.hide();
    }
  }

  @Listen('click')
  handleClickInside() {
    if (!this.opening) {
      this.clickPrevent = true;
    }
  }

  @Listen('click', { target: 'window' })
  handleAllClicks() {
    if (!this.clickPrevent && this.open && !this.opening) {
      this.hide();
      this.clickPrevent = false;
    }
    if (this.opening) {
      this.opening = false;
    }
    this.clickPrevent = false;
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    if (this.debounce !== null) {
      clearTimeout(this.debounce);
      this.debounce = null;
    }

    this.debounce = window.setTimeout(() => {
      this.positionElement();
      this.debounce = null;
    }, 200);
  }

  hide = () => {
    if (this.el.style.zIndex.length > 0) {
      this.left = this.origLeft;
      this.top = this.origTop;
      this.el.style.maxWidth = '';
      this.el.style.zIndex = '';
      this.el.style.inset = '';
      this.el.style.left = this.origLeft;
      this.el.style.top = this.origTop;
    }
    this.open = false;
  };

  openInformationPopup = () => {
    this.linkIsOpen.emit({ isOpen: this.open });
    this.opening = true;
    this.clickPrevent = false;
    this.open = true;
    this.el.style.opacity = '0';
  };

  renderPrice = () => {
    if (this.priceType === 'sale') {
      return (
        <Fragment>
          <lilu-price type="hit" size="big">
            {this.price}
          </lilu-price>{' '}
          <lilu-price type="sale" size="big">
            {this.oldprice}
          </lilu-price>
        </Fragment>
      );
    } else {
      return (
        <lilu-price type={this.priceType} size="big">
          {this.price}
        </lilu-price>
      );
    }
  };

  positionElement() {
    if (this.top && this.top !== 'undefined' && this.left && this.left !== 'undefined') {
      if (!this.open) {
        this.origLeft = this.left;
        this.origTop = this.top;

        this.el.style.left = this.left + '%';
        this.el.style.top = this.top + '%';
        this.el.style.right = 'auto';
      } else {
        let parentWidth = this.el.parentElement.clientWidth;
        let parentHeight = this.el.parentElement.clientHeight;
        let width = this.el.clientWidth;
        this.el.style.maxWidth = `${parentWidth - 40}px`;
        let height = this.el.clientHeight;
        let leftPx = (parentWidth / 100) * parseInt(this.left);
        let topPx = (parentHeight / 100) * parseInt(this.top);

        // 20px margin for the border of the image
        if (leftPx + width + 20 > parentWidth) {
          this.el.style.left = 'auto';
          this.el.style.right = '20px';
        }

        if (topPx + height + 20 > parentHeight) {
          this.el.style.bottom = '20px';
          this.el.style.top = 'auto';
        }

        this.el.style.opacity = '1';
        this.el.style.zIndex = '2';
      }
    }
  }

  componentDidRender() {
    this.positionElement();
  }

  renderPosition = () => {
    let parentWidth = this.el.parentElement.clientWidth;
    if (parentWidth > 0) this.el.style.maxWidth = `${parentWidth - 40}px`;

    if (this.top && this.top !== 'undefined' && this.left && this.left !== 'undefined') {
      return {
        left: this.left + '%',
        top: this.top + '%',
        opacity: this.open ? '0' : '1',
        zIndex: this.open ? '2' : '1',
        maxWidth: this.el.parentElement.clientWidth > 0 ? this.el.parentElement.clientWidth + 'px' : 'none',
      };
    }

    return null;
  };

  addToBasket() {
    $$$('lilu-mini-basket')[0].addProductToBasket(987654321);
  }

  render() {
    return (
      <Host>
        <div class="lilu-image-product-link">
          {this.open ? (
            <div class="lilu-image-product-link-details">
              <a href={this.producturl} class="lilu-image-product-link-title-wrapper">
                <span class="lilu-image-product-link-title">{this.titletext}</span>
                <lilu-icon type="icon-chevron-right" size="size-12 lg-size-14"></lilu-icon>
              </a>
              {this.renderPrice()}
            </div>
          ) : (
            <lilu-rounded-icon-button
              size="size-lg"
              color="white"
              icon="icon-plus"
              icon-size="size-14 lg-size-16"
              icon-color="nero"
              appearance="mansory"
              onClick={() => this.openInformationPopup()}
            ></lilu-rounded-icon-button>
          )}
        </div>
      </Host>
    );
  }
}
